var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React from 'react';
import { source } from 'react-aim';
import TdWebService from '../../service/TdWebService';
import Counter from '../common/Counter';
import LoginLink from './LoginLink';
import style from './userMenu.module.scss';
import UserMenuList from './UserMenuList';
const QUERY = gql `
  query UserMenuQuery {
    viewer {
      userId
      locale
      serverTime
      displayName
      companyName
      isLogin
      isBusiness
      isActiveBusiness
      buyer {
        approvalFlag
      }
      unreadMessageCount
    }
  }
`;
// @ts-ignore
let UserMenu = class UserMenu extends React.Component {
    // static fragments = {
    //   viewer: gql`
    //     fragment UserMenu_viewer on Viewer {
    //       userId
    //       locale
    //       serverTime
    //       displayName
    //       companyName
    //       isLogin
    //       isBusiness
    //       isActiveBusiness
    //       buyer {
    //         approvalFlag
    //       }
    //       unreadMessageCount
    //     }
    //   `,
    // };
    constructor(props) {
        super(props);
        this.state = {
            over: false,
        };
    }
    render() {
        const { viewer } = this.props;
        const { over } = this.state;
        let iconClassName = 'login';
        let image;
        let userMenuList;
        if (viewer && viewer.isLogin) {
            TdWebService.setMemberId(viewer.userId);
            if (over) {
                userMenuList = React.createElement(UserMenuList, { viewer: viewer });
            }
            iconClassName = 'user';
            if (viewer.isBusiness) {
                iconClassName = 'userbiz';
            }
            image = React.createElement(FontAwesomeIcon, { icon: faUser, size: '2x', className: style.userMenu });
        }
        else {
            image = React.createElement(LoginLink, null);
        }
        return (React.createElement("div", { id: "userMenu" },
            image,
            viewer && viewer.unreadMessageCount > 0 && (React.createElement(Counter, { top: true, count: viewer.unreadMessageCount })),
            userMenuList));
    }
};
UserMenu.propTypes = {
    viewer: PropTypes.any,
};
UserMenu = __decorate([
    source({
        mouseEnter: (props, component) => {
            // @ts-ignore
            return component.setState({ over: true });
        },
        mouseLeave: (props, component) => {
            // @ts-ignore
            return component.setState({ over: false });
        },
    }),
    __metadata("design:paramtypes", [Object])
], UserMenu);
UserMenu.fragments = {
    viewer: gql `
    fragment UserMenu_viewer on Viewer {
      userId
      locale
      serverTime
      displayName
      companyName
      isLogin
      isBusiness
      isActiveBusiness
      buyer {
        approvalFlag
      }
      unreadMessageCount
    }
  `,
};
export default UserMenu;
